export default "__VITE_ASSET__r6pFk0yY__"